export default {
  dataSource: [],
  skuId: []
}